export default __webpack_public_path__ + "static/media/landing_image.558bc462.jpg";